import ComponentResultatsCiblerBiens from 'components/ComplexTooltips/ResultatsCiblerBiens/ResultatsCiblerBiens'
import Translation from 'assets/default/translation.json'

export enum Tooltip {
  EmpriseAuSol,
  SurfaceTerrain,
  Localisation,
  TypeDeBien,
  Mitoyennete,
  Piscine,
  SurfaceHabitable,
  SurfaceHabitableAnnonce,
  NombreEtage,
  FormeParticuliereOuGarageAttenant,
  Montant,
  DateTransaction,
  NombrePiece,
  ResultatsCiblerBiens,
  CaracteristiquesMaison,
  Garage,
}

export const getTooltip = (tooltip: Tooltip): JSX.Element | undefined => {
  switch (tooltip) {
    case Tooltip.EmpriseAuSol:
      return (
        <div>
          <p>
            <b>
              C’est l’un des 2 éléments clés pour géolocaliser votre maison ou
              terrain.
            </b>
          </p>
          <p>
            Il permet à {Translation.common.produit} de{' '}
            <b>rechercher dans le cadastre</b> les biens qui pourraient
            correspondre.
          </p>
          <p>
            {Translation.common.produit} a{' '}
            <b>estimé pour vous l’emprise au sol de l’habitation principale</b>,
            grâce aux caractéristiques que vous avez saisies dans les champs
            ci-dessus. Vous pouvez néanmoins <b>modifier manuellement</b> cette
            estimation.
          </p>
          <p>
            Vous avez <b>un doute</b> sur certaines de vos données ? N’hésitez
            pas à <b>élargir la fourchette de l’emprise au sol</b>. Vous
            obtiendrez ainsi plus de résultats susceptibles de correspondre à la
            maison que vous recherchez et ferez le tri en fonction de son
            aspect.
          </p>
        </div>
      )
    case Tooltip.SurfaceTerrain:
      return (
        <div>
          <p>
            <b>
              C’est l’un des 2 éléments clés pour géolocaliser votre maison ou
              terrain.
            </b>
          </p>
          <p>
            Il permet à {Translation.common.produit} de{' '}
            <b>rechercher dans le cadastre et dans DVF</b> les biens qui
            pourraient correspondre.
          </p>
          <p>
            Il vous suffit de reporter la surface du terrain (ou mieux, si vous
            l’avez&nbsp;: de la parcelle) telle qu’elle est indiquée dans
            l’annonce.
          </p>
          <p>
            À noter&nbsp;: il peut arriver qu’un terrain soit composé de
            plusieurs parcelles, surtout dans les zones rurales où se trouvent
            de vastes terrains. Si vous pensez être dans ce cas, définissez une
            fourchette large.
          </p>
        </div>
      )
    case Tooltip.Localisation:
      return (
        <div>
          Votre zone de recherche correspond à{' '}
          <b>vos codes postaux de pige Yanport</b>.<br />
          Si un code postal est inclus dans une ville (exemple&nbsp;: 31500 est
          inclus dans la ville de Toulouse), vous pouvez rechercher la ville
          dans son ensemble.
        </div>
      )
    case Tooltip.TypeDeBien:
      return (
        <div>
          Vous pouvez cibler{' '}
          <b>les maisons (hors lotissements & copropriétés) et les terrains</b>
          .<br />
          <br />
          Pourquoi&nbsp;? Parce que {Translation.common.produit} va rechercher
          dans le cadastre et DVF a donc besoin de l’emprise au sol et la
          surface de la parcelle cadastrale.
          <br />
          <br />
          Vous ne pouvez donc pas cibler&nbsp;:
          <br />
          <ul>
            <li>
              Des appartements ou encore des pavillons en lotissement ou en
              copropriété
            </li>
            <li>Des maisons en VEFA</li>
          </ul>
        </div>
      )
    case Tooltip.CaracteristiquesMaison:
      return (
        <div>
          <b>Maison mitoyenne&nbsp;:</b>
          <br />
          <p>
            A sélectionner si la maison partage un ou plusieurs murs communs
            avec une ou plusieurs maisons voisines
          </p>
          <b>Piscine&nbsp;:</b>
          <br />
          <p>A sélectionner s’il s’agit d’une piscine extérieure :</p>
          <ul>
            <li>Enterrée dans le sol et mesurant plus de 10m²</li>
            <li>Hors sol et non déplaçable </li>
          </ul>
          <b>Attention&nbsp;: seules les maisons avec une piscine déclarée</b>{' '}
          s’affichent dans les résultats de la recherche. Si vous avez un doute,
          ne sélectionnez pas ce critère.
        </div>
      )
    case Tooltip.Mitoyennete:
      return (
        <div>
          Cochez «&nbsp;oui&nbsp;» si la maison partage{' '}
          <b>
            un ou plusieurs murs communs avec une ou plusieurs maisons voisines
          </b>
          . <br />
          Si vous avez un doute, cochez «&nbsp;Je ne sais pas&nbsp;».{' '}
        </div>
      )
    case Tooltip.Piscine:
      return (
        <div>
          <b>Cochez «&nbsp;oui&nbsp;» s’il s’agit d’une piscine extérieure :</b>
          <ul>
            <li>Enterrée dans le sol et mesurant plus de 10m²</li>
            <li>Hors sol et non déplaçable </li>
          </ul>
          <b>Attention&nbsp;: seules les maisons avec une piscine déclarée</b>{' '}
          s’affichent dans les résultats de la recherche. Si vous ne trouvez pas
          la maison avec piscine que vous recherchez, réessayez en cochant
          «&nbsp;non&nbsp;».
          <br />
          <br />
          <b>Cochez «&nbsp;non&nbsp;» s’il s’agit d’une piscine&nbsp;:</b>
          <ul>
            <li>
              Enterrée dans le sol et mesurant moins de 10 m2 (assimilée à un
              jacuzzi, spa, etc).
            </li>
            <li>Hors-sol et gonflable/en kit (déplaçable)</li>
            <li>
              Intérieure (qui se trouve donc dans l’habitation principale)
            </li>
          </ul>
          Si vous avez un doute, cochez «&nbsp;Je ne sais pas&nbsp;».
        </div>
      )
    case Tooltip.SurfaceHabitable:
      return (
        <div>
          <p>Entrez la surface habitable</p>
        </div>
      )
    case Tooltip.SurfaceHabitableAnnonce:
      return (
        <div>
          Reportez ici <b>la surface habitable de l’habitation principale</b>,
          telle qu’elle est indiquée dans l’annonce.
          <br />
          <br />
          Qu’est-ce que la surface habitable&nbsp;?
          <br />
          C’est{' '}
          <b>
            la surface de plancher de la maison, de laquelle on déduit les
            surfaces non habitables
          </b>
          &nbsp;:
          <br />
          <ul>
            <li>
              Murs, cloisons, marches et porches, gaines, embrasures de portes
              et fenêtres, parties d’une hauteur inférieure à 1,80 m
            </li>
            <li>
              Sous-sols, garages, greniers, combles non aménagés, réserves,
              remises
            </li>
            <li>Terrasses (même couvertes), balcons</li>
          </ul>
          <br />
          <b>
            Les combles aménagés, extensions, garages réaménagés en chambres ou
            assimilé font partie de la surface habitable… encore faut-il qu’ils
            aient été déclarés
          </b>{' '}
          pour être recensées dans DVF et le cadastre (les deux sources de
          {Translation.common.produit}). Si vous ne trouvez pas la maison que
          vous recherchez, réessayez en retirant cette fois les surfaces
          susceptibles de ne pas avoir été déclarées.
          <br />
          <br />
          Il arrive aussi que{' '}
          <b>certains vendeurs gourmands grossissent la surface habitable</b> de
          la maison&nbsp;dans l’annonce&nbsp;pour en tirer un meilleur prix : en
          y incluant une chambre en sous-sol, par exemple. Si vous ne trouvez
          pas la maison que vous recherchez, réessayez en retirant cette fois
          les surfaces susceptibles d’avoir été inclues.
          <br />
          <br />
          Si la surface habitable indiquée dans l’annonce{' '}
          <b>ne vous paraît pas fiable</b>, cocher «&nbsp;Ne pas utiliser ce
          critère dans ma recherche&nbsp;».
        </div>
      )
    case Tooltip.NombreEtage:
      return (
        <div>
          Un étage est un espace entre deux planchers au-dessus du
          rez-de-chaussée :
          <ul>
            <li>Exemple 1 : une maison de plain-pied a 0 étage.</li>
            <li>
              Exemple 2 : une maison avec rez-de-chaussée, un étage et combles
              aménagés a 2 étages.
            </li>
          </ul>
          Attention : si les combles aménagés n’ont pas été déclarés par le
          propriétaire, la maison ne ressortira pas dans votre recherche.
          Réessayez en enlevant 1 étage.
        </div>
      )
    case Tooltip.FormeParticuliereOuGarageAttenant:
      return (
        <div>
          Considérez qu’une maison a une forme particulière dès lors qu’elle a{' '}
          <b>plusieurs niveaux qui ont des surfaces différentes</b>.
          <ul>
            <li>
              Exemple 1&nbsp;: une maison avec un 1er étage plus exigu car sous
              les toits.
            </li>
            <li>
              Exemple 2&nbsp;: une maison à étage avec une véranda ajoutée au
              rez-de-chaussée
            </li>
          </ul>
          Considérez que le garage est attenant si les conditions suivantes sont
          réunies&nbsp;:
          <ul>
            <li>
              C’est un espace <b>fermé</b> utilisé pour faire{' '}
              <b>stationner un ou plusieurs véhicule(s)</b>. Si le garage a été
              réaménagé en chambre ou autre espace habitable, cochez donc
              «&nbsp;non&nbsp;».
            </li>
            <li>
              Il a{' '}
              <b>
                un ou plusieurs mur(s) commun(s) avec le bâtiment d’habitation
              </b>
              . Il est donc accessible depuis le bâtiment d’habitation sans
              avoir à passer par l’extérieur.
            </li>
          </ul>
        </div>
      )
    case Tooltip.ResultatsCiblerBiens:
      return <ComponentResultatsCiblerBiens />
    case Tooltip.Garage:
      return (
        <p>
          Seule la surface d’un garage attenant est prise en compte dans
          l’estimation de l’emprise au sol.
        </p>
      )
    default:
      return undefined
  }
}
